<template>
	<div class="dialogBox">
		<el-dialog :title="$t('agentCommissionSettings')" :visible.sync="innerVisible" width="55%" center @closed="closedFun">
			<div class="content">
				<el-form inline :model="info">
					<el-form-item>
						<el-button type="primary" icon="el-icon-plus" class="mr10" @click="showadd()">{{$t('Add')}}</el-button>
					</el-form-item>
				</el-form>
				<el-table :data="setTableData" style="width: 100%" border v-loading="loading">
					<el-table-column align="center" :label="$t('GameName')" width="240">
						<template slot-scope="scope">
							<span>{{ gamemap[scope.row.GameId] || '--' }}({{ roommap[scope.row.RoomLevel] || '--' }})</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="FenChengRate" :label="$t('RevenueShareRatio')" width="120"></el-table-column>
					<el-table-column align="center" prop="State" :label="$t('Status')" width="160">
						<template slot-scope="scope">
							<span :class="[scope.row.State == 1 ? '' : 'red']">{{ scope.row.State == 1 ? $t('Enable') : $t('deactivate') }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center"  :label="$t('Actions')">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-eleme" class="red" v-if="scope.row.State == 1" @click="edit(scope.row, 2)">停用</el-button>
							<el-button type="text" icon="el-icon-eleme" v-else @click="edit(scope.row, 1)">{{$t('Enable')}}</el-button>
							<el-button type="text" icon="el-icon-edit" @click="showedit(scope.row)">{{$t('Edit')}}</el-button>
							<el-button type="text" icon="el-icon-delete" @click="deleteList(scope.row)">{{$t('Delete')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<el-dialog :title="title" :visible.sync="addSettingVisible" center width="28%" :close-on-click-modal="false" @closed="closedFun">
			<el-form inline :model="addModel" label-width="80px">
				<el-form-item :label="$t('GameName')">
					<el-select v-model="addModel.GameId" :placeholder="$t('Game')" style="width: 360px" :disabled="disabled">
						<el-option v-for="item in hgames" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('RoomLevel')">
					<el-select v-model="addModel.RoomLevel"  :placeholder="$t('Room')" style="width: 360px" :disabled="disabled" clearable>
						<el-option v-for="item in hrooms" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('RevenueShareRatio')+':'">
					<el-input v-model="addModel.FenChengRate" :placeholder="$t('enterCommissionRatio')" style="width: 360px"></el-input>
				</el-form-item>
				<el-form-item :label="$t('Status')">
					<el-select v-model="addModel.State" :placeholder="$t('SelectStatus')" style="width: 360px">
						<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" class="confirmBtn" @click="confirmAdd()">{{$t('Confirm')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { app } from '@/api/app.js'
import base from '@/api/base.js'
export default {
	extends: base,
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		id: {
			type: Number,
			default: '',
		},
	},
	computed: {
		innerVisible: {
			get: function () {
				return this.show
			},
			set: function (val) {
				this.$emit('update:show', val)
			},
		},
	},
	data() {
		return {
			loading: false,
			UserId: null,
			setTableData: [],
			info: {},
			addSettingVisible: false,
			addModel: {
				GameId: null,
				RewardRate: null,
				FeeRate: null,
				State: 1,
			},
			options: [
				{ name: this.$t('Enable'), id: 1 },
				{ name: this.$t('deactivate'), id: 2 },
			],
			list: {},
			title: '',
			disabled: false,
			type: 1,
		}
	},
	created() {
		this.getList()
	},
	methods: {
		showadd() {
			this.title = this.$t('addAgentCommission')
			this.addModel = {
				GameId: null,
				RewardRate: null,
				FeeRate: null,
				State: 1,
			}
			this.addSettingVisible = true
		},
		showedit(item) {
			this.addModel = app.clone(item)
			this.title = '编辑代理分成'
			this.addSettingVisible = true
		},
		getList() {
			let data = {
				SellerId: this.filters.SellerId,
				UserId: this.id,
			}
			app.post('/agent/fencheng_list', data, (res) => {
				this.setTableData = res.data
			})
		},
		confirmAdd(type) {
			app.getGoogleCode((GoogleCode) => {
				this.loading = true
				let obj = {
					SellerId: this.filters.SellerId,
					UserId: this.id,
					GameId: this.addModel.GameId,
					RoomLevel: this.addModel.RoomLevel,
					FenChengRate: Number(this.addModel.FenChengRate),
					State: this.addModel.State,
					GoogleCode: GoogleCode,
				}
				if (this.title == this.$t('addAgentCommission')) {
					app.post('/agent/fencheng_add', obj, () => {
						this.addSettingVisible = false
						this.getList()
						this.$message.success('添加成功')
					})
				}
				if (this.title == '编辑代理分成') {
					app.post('/agent/fencheng_modify', obj, () => {
						this.addSettingVisible = false
						this.getList()
						this.$message.success(this.$t('OperationSuccess'))
					})
				}
				this.loading = false
			})
		},
		edit(item, state) {
			this.addModel = app.clone(item)
			this.addModel.State = state
			app.getGoogleCode((GoogleCode) => {
				let obj = {
					SellerId: this.filters.SellerId,
					UserId: this.id,
					GameId: this.addModel.GameId,
					RoomLevel: this.addModel.RoomLevel,
					FenChengRate: Number(this.addModel.FenChengRate),
					State: this.addModel.State,
					GoogleCode: GoogleCode,
				}
				app.post('/agent/fencheng_modify', obj, () => {
					this.addSettingVisible = false
					this.getList()
					this.$message.success(this.$t('OperationSuccess'))
				})
			})
		},
		deleteList(item) {
			app.getGoogleCode((GoogleCode) => {
				this.loading = true
				let obj = {
					SellerId: this.filters.SellerId,
					UserId: this.id,
					GameId: item.GameId,
					RoomLevel: item.RoomLevel,
					GoogleCode: GoogleCode,
				}
				app.post('/agent/fencheng_delete', obj, () => {
					this.getList()
					this.$message.success('删除成功')
				})
				this.loading = false
			})
		},
		closedFun() {
			this.addModel = {}
			this.disabled = false
		},
	},
}
</script>

<style scoped>
.content {
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.confirmBtn {
	width: 160px;
	height: 40px;
}
</style>
